import {
  Divider,
  Grid,
  GRID_VARIANT_VERTICAL_BIG,
  GridCell,
  Link,
  LINK_VARIANT_EXTRALIGHT,
  PanelCollapsible,
  SkeletonLoader,
  SPACING_8,
  SpacingVertical,
  Text,
  Title,
  TITLE_VARIANT_S
} from 'mailup-web-components'
import {
  changeWizardStepCallback,
  getGroupByIdCallback,
  getMessageDetailCallback,
  getSmsDetailCallback
} from 'Pages/Task/recoil/callbacks/callbacks'
import {
  ACTION_MOVE_COPY,
  ACTION_SEND_MESSAGE,
  ACTION_SEND_SMS,
  recapState,
  taskState
} from 'Pages/Task/recoil/state/task'
import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilState, useRecoilValue } from 'recoil'

const Action = () => {
  const intl = useIntl()
  const [{ actionExpanded, subject, fromGroup, toGroup }, setRecapState] =
    useRecoilState(recapState)
  const changeWizardStep = useRecoilCallback(changeWizardStepCallback, [])
  const getMessageDetail = useRecoilCallback(getMessageDetailCallback, [])
  const getSmsDetail = useRecoilCallback(getSmsDetailCallback, [])
  const getGroupById = useRecoilCallback(getGroupByIdCallback, [])
  const task = useRecoilValue(taskState)

  const getGroupDetail = async () => {
    const [fromGroup, toGroup] = await Promise.all([
      task.Detail.FromGroup > 0 ? getGroupById(task.Detail.FromGroup) : null,
      task.Detail.ToGroup > 0 ? getGroupById(task.Detail.ToGroup) : null
    ])
    setRecapState((prev) => ({
      ...prev,
      fromGroup:
        task.Detail.FromGroup === 0
          ? intl.formatMessage({ id: 'Load.TriggersDetail.AllGroups' })
          : fromGroup
            ? 'ID ' + fromGroup.Id + ' - ' + fromGroup.Name
            : '',
      toGroup:
        task.Detail.ToGroup === 0
          ? intl.formatMessage({ id: 'Load.TriggersDetail.AllGroups' })
          : toGroup
            ? 'ID ' + toGroup.Id + ' - ' + toGroup.Name
            : ''
    }))
  }
  useEffect(() => {
    if (task.Detail.Action === ACTION_SEND_MESSAGE) {
      getMessageDetail(task.Detail.IdMessage)
    }

    if (task.Detail.Action === ACTION_SEND_SMS) {
      getSmsDetail(task.Detail.IdMessage)
    }

    getGroupDetail()
  }, [])

  const onCanchePanel = () => {
    setRecapState((prev) => ({
      ...prev,
      actionExpanded: !prev.actionExpanded
    }))
  }

  const goToStep = () => {
    changeWizardStep(2)
  }

  return (
    <PanelCollapsible
      title={intl.formatMessage({ id: 'Load.Task.Step2Action' })}
      collapsed={!actionExpanded}
      onChange={onCanchePanel}
      beforeCollapseChildren={
        <Link
          data-mu-test='task-5-actions'
          onClick={goToStep}
          variant={LINK_VARIANT_EXTRALIGHT}
        >
          {intl.formatMessage({ id: 'Load.Task.ReviewEdit' })}
        </Link>
      }
    >
      <Grid cols={3} variantVertical={GRID_VARIANT_VERTICAL_BIG}>
        {task.Detail.Action === ACTION_SEND_MESSAGE && (
          <>
            <GridCell span={1}>
              <Title variant={TITLE_VARIANT_S}>
                {intl.formatMessage({ id: 'Load.Task.ReviewSelectedAction' })}
              </Title>
              <SpacingVertical variant={SPACING_8} />

              <Text>
                {intl.formatMessage({ id: 'Load.Task.ActionsEmail' })}
              </Text>
            </GridCell>
            <GridCell span={1}>
              <Title variant={TITLE_VARIANT_S}>
                {intl.formatMessage({ id: 'Load.Task.ReviewSelectedMessage' })}
              </Title>
              <SpacingVertical variant={SPACING_8} />
              <Text>
                {!subject ? (
                  <SkeletonLoader />
                ) : (
                  'ID ' + task.Detail.IdMessage + ' - ' + subject
                )}
              </Text>
            </GridCell>
            <GridCell span={1}>
              <Title variant={TITLE_VARIANT_S}>
                {intl.formatMessage({ id: 'Load.Task.ReviewCustomSender' })}
              </Title>
              <SpacingVertical variant={SPACING_8} />

              <Text>
                {task.Detail.CustomSender
                  ? intl.formatMessage({ id: 'Load.MailupCommon.Yes' })
                  : intl.formatMessage({ id: 'Load.MailupCommon.No' })}
              </Text>
            </GridCell>
            <GridCell span={1}>
              <Title variant={TITLE_VARIANT_S}>
                {intl.formatMessage({ id: 'Load.Common.SenderEmailLabel' })}
              </Title>
              <SpacingVertical variant={SPACING_8} />
              <Text>{task.Detail.Sender}</Text>
            </GridCell>
            <GridCell span={1}>
              <Title variant={TITLE_VARIANT_S}>
                {intl.formatMessage({ id: 'Load.Common.SenderNameLabel' })}
              </Title>
              <SpacingVertical variant={SPACING_8} />
              <Text>{task.Detail.SenderName}</Text>
            </GridCell>
            <GridCell span={1}>
              <Title variant={TITLE_VARIANT_S}>
                {intl.formatMessage({ id: 'Load.Common.ReplyToEmailLabel' })}
              </Title>
              <SpacingVertical variant={SPACING_8} />
              <Text>{task.Detail.ReplyTo}</Text>
            </GridCell>
          </>
        )}
        {task.Detail.Action === ACTION_SEND_SMS && (
          <>
            <GridCell span={1}>
              <Title variant={TITLE_VARIANT_S}>
                {intl.formatMessage({ id: 'Load.Task.ReviewSelectedAction' })}
              </Title>
              <SpacingVertical variant={SPACING_8} />

              <Text>{intl.formatMessage({ id: 'Load.Task.ActionsSMS' })}</Text>
            </GridCell>
            <GridCell span={1}>
              <Title variant={TITLE_VARIANT_S}>
                {intl.formatMessage({
                  id: 'Load.Task.ActionsSegmentMovePrevGroup'
                })}
              </Title>
              <SpacingVertical variant={SPACING_8} />
              <Text>
                {!subject ? (
                  <SkeletonLoader />
                ) : (
                  'ID ' + task.Detail.IdMessage + ' - ' + subject
                )}
              </Text>
            </GridCell>
            <GridCell span={1}>
              <Title variant={TITLE_VARIANT_S}>
                {intl.formatMessage({ id: 'Load.MailupCommon.Sender' })}
              </Title>
              <SpacingVertical variant={SPACING_8} />
              <Text>{task.Detail.Sender}</Text>
            </GridCell>
          </>
        )}
      </Grid>
      {task.Detail.Action !== ACTION_MOVE_COPY && (
        <>
          <SpacingVertical />
          <Divider />
          <SpacingVertical />
        </>
      )}
      <Grid cols={3}>
        <GridCell
          span={task.Detail.FromGroup > 0 && task.Detail.ToGroup === -1 ? 3 : 1}
        >
          <Title variant={TITLE_VARIANT_S}>
            {task.Detail.Action !== ACTION_MOVE_COPY
              ? intl.formatMessage({
                  id: 'Load.Task.ReviewAfterSend'
                })
              : intl.formatMessage({
                  id: 'Load.Task.ReviewSelectedAction'
                })}
          </Title>
          <SpacingVertical variant={SPACING_8} />
          <Text>
            {task.Detail.FromGroup === -1 &&
              task.Detail.ToGroup > 0 &&
              intl.formatMessage({ id: 'Load.Task.ActionsSegmentCopy' })}
            {task.Detail.FromGroup > -1 &&
              task.Detail.ToGroup > 0 &&
              intl.formatMessage({ id: 'Load.Task.ActionsSegmentMove' })}
            {task.Detail.ToGroup === 0 &&
              intl.formatMessage({ id: 'Load.Task.ActionsSegmentDoNothing' })}
            {task.Detail.FromGroup > 0 && task.Detail.ToGroup === -1 && (
              <>
                {intl.formatMessage({
                  id: 'Load.Task.ActionsSegmentEmptyGroup'
                })}
                {' - '} <Text htmlElement='span'>{fromGroup}</Text>
              </>
            )}
          </Text>
        </GridCell>
        {task.Detail.ToGroup > 0 && (
          <>
            {task.Detail.FromGroup > -1 && task.Detail.ToGroup > 0 && (
              <GridCell span={1}>
                <Title variant={TITLE_VARIANT_S}>
                  {intl.formatMessage({
                    id: 'Load.Task.ActionsSegmentMovePrevGroup'
                  })}
                </Title>
                <SpacingVertical variant={SPACING_8} />
                <Text>{fromGroup}</Text>
              </GridCell>
            )}
            <GridCell span={1}>
              <Title variant={TITLE_VARIANT_S}>
                {intl.formatMessage({
                  id: 'Load.Task.ActionsSegmentMoveDestGroup'
                })}
              </Title>
              <SpacingVertical variant={SPACING_8} />
              <Text>{toGroup}</Text>
            </GridCell>
          </>
        )}
      </Grid>
    </PanelCollapsible>
  )
}

export default Action
